var map = {
	"./Rectangle 547.png": 8893,
	"./vtb 1.png": 5931,
	"./Гленкор.png": 1069,
	"./Микоян-1.png": 2935,
	"./Микоян-2.png": 6103,
	"./Микоян.png": 2759,
	"./загружено 1.png": 2058,
	"./лого-1.png": 6495,
	"./лого-2.png": 1397,
	"./лого-3.png": 2076,
	"./лого-4.png": 3518,
	"./лого-5.png": 9367,
	"./лого-6.png": 2979,
	"./лого-7.png": 1527,
	"./лого.png": 1460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3370;